import {PartType} from '@dv5/domain'

export const partTypesTitle: Record<PartType, string> = {
    [PartType.MARKDOWN]: 'Markdown',
    [PartType.PLAINTEXT]: 'Plain Text',
    [PartType.CSV_TABLE]: 'CSV Table',
    [PartType.DIARY]: 'Diary',
    [PartType.SECRET]: 'Secret',
}
